import { SelectedLocationRow } from './selected_location_row'

export const LocationRowFallback = ({
  location,
  title,
  subtitle,
  removeLocation,
  startEditing,
  isReadOnly,
  isDisabled,
}) => {
  const editHandler = !isReadOnly && !isDisabled ? startEditing : undefined

  return (
    <SelectedLocationRow
      kind={location.kind}
      title={title}
      subtitle={subtitle}
      onRemove={removeLocation}
      onRowClick={editHandler}
      onEdit={editHandler}
      isReadOnly={isReadOnly}
      isDisabled={isDisabled}
    />
  )
}
